import React, { createRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';

// Styles
import './contact-details-tab.scss';

// Components
import { BusinessAddress, TBusinessAddressRef } from './children/business-address/business-address';
import {
  CompanyContactDetails,
  TCompanyContactDetailsRef
} from './children/company-contact-details/company-contact-details';

// Store entities
import { getCompanyState } from '../../../../store/company/company.selectors';

export type TContactDetailsTabRef = {
  isHasChanges: () => boolean;
  resetState: () => void;
};

type TContactDetailsTabProps = {};

export const ContactDetailsTab = forwardRef<TContactDetailsTabRef, TContactDetailsTabProps>((
  {}: TContactDetailsTabProps, ref
) => {
  const companyContactDetailsRef = createRef<TCompanyContactDetailsRef>();
  const businessAddressRef = createRef<TBusinessAddressRef>();

  const {company, allCountries} = useSelector(getCompanyState);

  useImperativeHandle(ref, () => ({
    isHasChanges(): boolean {
      return !!companyContactDetailsRef.current?.isHasChanges() ||
        !!businessAddressRef.current?.isHasChanges();
    },
    resetState(): void {
      companyContactDetailsRef.current?.resetState();
      businessAddressRef.current?.resetState();
    }
  }));

  return (<>
    {
      company && <div className="contact-details-tab">
        <div className="contact-details-tab--description business--description">
          <p>In this section, please add contact details and other essential business information for your clients. By
            using this, your clients will be able to contact you regarding the following matters: checking or requesting
            Consultants' availability if needed, sharing their experience with your Consultants, getting assistance with
            payments, documents, or any concerns.</p>
          <p>Keeping your business info updated ensures a smoother experience!</p>
        </div>
        <div className="contact-details-tab--item">
          <CompanyContactDetails ref={companyContactDetailsRef} company={company}/>
        </div>
        <div className="contact-details-tab--item">
          <BusinessAddress ref={businessAddressRef} company={company} countries={allCountries}/>
        </div>
      </div>
    }
  </>);
})
